module.exports = __webpack_public_path__ + "static/Sarjeel-Yusuf-972e2946a32f3c76765257910f4e8790.png";